/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

let fbSdkReady = false

exports.onClientEntry = () => {
  const fbRoot = document.createElement('div')
  fbRoot.id = 'fb-root'
  document.body.prepend(fbRoot)

  window.fbAsyncInit = function () {
    window.FB.init({ appId: '879817429124153', version: 'v25.0', xfbml: false })
    fbSdkReady = true
    window.FB.XFBML.parse()
  }

  ;(function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) return
    js = d.createElement(s)
    js.id = id
    js.async = true
    js.defer = true
    js.crossOrigin = 'anonymous'
    js.src = 'https://connect.facebook.net/fr_FR/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  }(document, 'script', 'facebook-jssdk'))
}

exports.onRouteUpdate = () => {
  if (fbSdkReady && window.FB) {
    window.FB.XFBML.parse()
  }
}
